import { render, staticRenderFns } from "./ChatbotAiFaq.vue?vue&type=template&id=a955570a&"
import script from "./ChatbotAiFaq.vue?vue&type=script&lang=ts&"
export * from "./ChatbotAiFaq.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports